import React from 'react'

import { Grid as GridBase, Divider as DividerBase, styled } from '@mui/material'
import { ExpandMore as ExpandMoreBase } from '@mui/icons-material'
import {
  Tag as TagBase,
  CheckBox as CheckBoxBase,
  DatePicker as DatePickerBase
} from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const CancelButton = styled('a')`
  color: ${props => props.theme.palette.red[50]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  text-decoration: none;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    visibility: ${props => props.visibility};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  height: ${props => props.height};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const Divider = styled(DividerBase)``

export const LineJump = styled('br')``

export const Prefix = styled('span')`
  padding: 0 0 0 10px;
`

export const CheckBox = styled(CheckBoxBase)`
  &.MuiFormControlLabel-root .MuiFormControlLabel-label {
    color: ${props => props.theme.palette.gray[75]};
    font-size: 14px;
    margin: 3px 0 0;
  }
`

export const Anchor = styled('div')`
  border-bottom: 1px solid ${props => props.theme.palette.brand.black1};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`

export const AnchorText = styled('span')`
  color: ${props => props.theme.palette.brand.black2};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  margin: 0 16px 0 0;
  pointer-events: none;
  user-select: none;
`

export const AnchorIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.primary};
    font-size: 24px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const DatePicker = styled(({ className, ...props }) => (
  <DatePickerBase
    {...props}
    PopoverProps={{
      ...props.PopoverProps,
      anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      classes: { ...props.PopoverProps?.classes, paper: className },
      transformOrigin: { horizontal: 'left', vertical: 'top' }
    }}
    variant="inline"
  />
))`
  &.MuiPopover-paper {
    box-shadow: 0 3px 6px ${props => props.theme.palette.gray[0.16]};
  }

  &.MuiPopover-paper .MuiPickersBasePicker-container {
    .MuiPickersToolbar-toolbar {
      background-color: ${props => props.theme.palette.blue[50]};
    }

    .MuiPickersToolbar-toolbar .MuiButtonBase-root:hover {
      background-color: transparent;
    }

    .MuiTypography-subtitle1,
    .MuiTypography-body1 {
      font-size: 16px;
    }

    .MuiTypography-h4 {
      font-size: 34px;
    }

    .MuiTypography-caption {
      font-size: 14px;
    }

    .MuiTypography-body2 {
      font-size: 14px;
    }

    .MuiTypography-h5 {
      font-size: 24px;
    }

    .MuiPickersCalendarHeader-iconButton .MuiSvgIcon-root {
      font-size: 24px;
    }
  }

  &.MuiPopover-paper .MuiPickersDay-day {
    color: ${props => props.theme.palette.gray[20]};
  }

  &.MuiPopover-paper .MuiPickersDay-current {
    color: ${props => props.theme.palette.blue[50]} !important;
  }

  &.MuiPopover-paper .MuiPickersDay-dayDisabled,
  &.MuiPopover-paper .MuiPickersCalendarHeader-dayLabel {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiPickersDay-daySelected {
    background-color: ${props => props.theme.palette.blue[50]} !important;
    color: ${props => props.theme.palette.brand.white} !important;
  }

  &.MuiPopover-paper .MuiPickersCalendarHeader-transitionContainer .MuiTypography-body1 {
    color: ${props => props.theme.palette.gray[20]};
  }

  &.MuiPopover-paper .MuiPickersCalendarHeader-iconButton {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiIconButton-root.Mui-disabled {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiPickersYear-root {
    color: ${props => props.theme.palette.gray[20]};
  }

  &.MuiPopover-paper .MuiPickersYear-yearDisabled {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiPickersYear-yearSelected {
    color: ${props => props.theme.palette.blue[50]} !important;
  }

  &.MuiPopover-paper .MuiDialogActions-root {
    display: none !important;
  }

  &.MuiPopover-paper .MuiTouchRipple-root {
    display: none;
  }
`
export const Tag = styled(TagBase)`
  &.MuiPaper-root {
    display: inline-flex;
  }
`
export const Strong = styled('span')`
  font-weight: bold;
`
